import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Input,
  Button,
  IconButton,
  TrashIcon
} from '@animoto/components/lib/es/design-system';
import { api, httpMethods } from '@animoto/appservice-client';
import moment from 'moment';

import { getUserAttribute } from '../../../../utils/userWrapper';

import './Comment.module.css';

export default function Comment({
  comment, comments, setComments, setRefetch
}) {
  const [replyInput, setReplyInput] = useState('');
  const [isReplying, setIsReplying] = useState(false);

  const getDisplayTime = (seconds) => {
    let display = '';
    const minutes = Math.floor(seconds / 60);
    if (minutes < 10) {
      display += '0';
    }
    display += minutes;
    display += ':';
    const displaySeconds = Math.floor(seconds % 60);
    if (displaySeconds < 10) {
      display += '0';
    }
    display += displaySeconds;

    return display;
  };

  return (
    <div>
      <span>
        {getDisplayTime(comment.timestamp)} {comment.content} - {comment.display_name} ({moment(comment.created_at).fromNow()})
      </span>
      {comment.user_id === getUserAttribute('id') && (
        <IconButton
          onClick={async () => {
            const response = await api({
              path   : comment.links.self,
              method : httpMethods.DELETE,
              token  : window.user_token
            });
            if (response.ok) {
              setRefetch(true);
            }
          }}
        >
          <TrashIcon />
        </IconButton>
      )}
      {comment.comments.map((innerComment) => (
        <div key={innerComment.links.self} styleName="comment-wrapper">
          <span>
            {innerComment.content} - {innerComment.display_name} ({moment(innerComment.created_at).fromNow()})
          </span>
          {innerComment.user_id === getUserAttribute('id') && (
            <IconButton
              onClick={async () => {
                const response = await api({
                  path   : innerComment.links.self,
                  method : httpMethods.DELETE,
                  token  : window.user_token
                });
                if (response.ok) {
                  setRefetch(true);
                }
              }}
            >
              <TrashIcon />
            </IconButton>
          )}
        </div>
      ))}
      {isReplying ? (
        <>
          <Input name="comment-reply" onChange={(_, val) => { setReplyInput(val); }} value={replyInput} />
          <Button
            onClick={async () => {
              const response = await api({
                path   : '/a/comments',
                method : httpMethods.POST,
                token  : window.user_token || window.client_token,
                body   : {
                  content    : replyInput,
                  comment_id : comment.id,
                  user_id    : getUserAttribute('id')
                }
              });
              if (response.ok) {
                const parsedResponse = await response.json();
                comment.comments = comment.comments.concat(parsedResponse.response.payload.comment);
                setComments(comments);
              }
              setIsReplying(false);
            }}
            size="small"
            type="secondary"
          >
            Submit
          </Button>
        </>
      ) : (
        <Button
          onClick={() => {
            setIsReplying(true);
          }}
          size="small"
          type="secondary"
        >
          Reply
        </Button>
      )}
    </div>
  );
}

const commentPropType = PropTypes.shape({
  comments     : PropTypes.arrayOf(PropTypes.object),
  content      : PropTypes.string.isRequired,
  created_at   : PropTypes.string.isRequired,
  display_name : PropTypes.string.isRequired,
  id           : PropTypes.number.isRequired,
  links        : PropTypes.shape({
    self : PropTypes.string.isRequired
  }).isRequired,
  timestamp : PropTypes.number.isRequired,
  user_id   : PropTypes.number.isRequired
});

Comment.propTypes = {
  comment     : commentPropType.isRequired,
  comments    : PropTypes.arrayOf(commentPropType).isRequired,
  setComments : PropTypes.func.isRequired,
  setRefetch  : PropTypes.func.isRequired
};
